module.exports = __webpack_public_path__ + "static/slider-2-2-movil-a30869a3f6ba2cc1473ef3ce500181ec.jpg";